import { useDispatch } from "react-redux";
import { ActionTypeConflictProposal, useApproveRejectProposalConflictMutation } from "../../api/gms/proposal/proposal-api";
import { useToastify } from "../../library/toastify/toast-provider";
import { clearApproveRejectConflictProposal } from "../../features/conflict-proposal/conflict-proposal-slice";

export const useConflictProposalActions = () => {

    const dispatch = useDispatch()
    const { showToastNotify } = useToastify();
    const [approveRejectProposalConflict, { isLoading: isLoadingApproveRejectProposalConflict }] = useApproveRejectProposalConflictMutation();

    const handleApprovedRejectConflictProposal = async (proposalId: number | null, actionType: null | ActionTypeConflictProposal) => {
        
        try {
            if (!proposalId || proposalId === null || proposalId <= 0) {
                showToastNotify("Proposal id is required.", "warning");
                return;
            }

            if (!actionType || proposalId === null) {
                showToastNotify("Action type is required.", "warning");
                return;
            }

            const response = await approveRejectProposalConflict({
                proposalId,
                actionType,
            }).unwrap();
            dispatch(clearApproveRejectConflictProposal())
            showToastNotify(`${response?.message ?? 'Update successfully'}`, "success");
        } catch (error: any) {
            showToastNotify(`${error?.message ?? 'Failed to update proposal'}`, "error");
        }
    }

    return {
        handleApprovedRejectConflictProposal,
        isLoadingApproveRejectProposalConflict,
    }
}